import { tenantQuery } from "@common/api"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, Outlet } from "@tanstack/react-router"
import { TenantJobs } from "../-components/tenant-jobs"
import { TenantSettingsForm } from "../-components/tenant-settings-form"

export const Route = createFileRoute(
  "/_layout/settings/system_/tenants/$tenantId/settings",
)({
  staticData: { breadcrumb: "Tenant Settings" },
  component: TenantSettingsTab,
})

function TenantSettingsTab() {
  const { tenantId } = Route.useParams()
  const { data: tenant } = useSuspenseQuery(
    tenantQuery({ tenant_id: tenantId }),
  )
  return (
    <>
      <TenantSettingsForm tenant={tenant} />
      <TenantJobs />
      <Outlet />
    </>
  )
}
